export const PT_PRICE_STICKER = Symbol('priceSticker');
export const PT_PRICE_LOYALTY = Symbol('priceLoyalty');
export const PT_PRICE_COMBI = Symbol('priceCombi');
export const PT_PRICE_BUNDLE = Symbol('priceBundle');
export const PT_PRICE_DISCOUNT = Symbol('priceDiscount');
